<template>
  <div class="vch-media-gallery__wrapper">
    <slot />

    <vch-carousel-indicator
      indicator-type="numbers"
      item-selector=".vch-media-gallery-mobile .vch-media-gallery__item"
      media-query-list="(max-width: 1023px)"
      :aria-pagination-label="paginationLabel"
      :aria-item-label="itemLabel"
      :key="lastUpdate"
    />
    <div class="vch-media-gallery_sample">
      <ul>
        <li class="vch-media-gallery__item__video">
          <div class="vch-media-gallery__item-img-wrapper">
            <iframe
              class="youtube-player youtube-player--desktop"
              title="desktop video"
            ></iframe>
            <iframe
              class="youtube-player youtube-player--mobile"
              title="mobile video"
            ></iframe>
          </div>
        </li>
        <li class="vch-media-gallery__item__image">
          <div class="vch-media-gallery__item-img-wrapper primary-image">
            <picture>
              <source data-width="432" srcset="" media="(min-width: 1600px)" />
              <source data-width="339" srcset="" media="(min-width: 1280px)" />
              <source data-width="238" srcset="" media="(min-width: 1024px)" />
              <source data-width="728" srcset="" media="(min-width: 425px)" />
              <img alt="" src="" class="vch-media-gallery__item-img-element" />
            </picture>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { busName } from 'Directives/variant-selector/variant-selector';

export default {
  name: 'vch-media-gallery',
  data() {
    return {
      variantMedia: {},
      mediaItemElms: [],
      defaultSizeAttr: '',
      lastUpdate: Date.now(),
    };
  },
  props: {
    paginationLabel: {
      type: String,
      required: false,
      default: '',
    },
    itemLabel: {
      type: String,
      required: false,
      default: '',
    },
    variantMediaItems: {
      type: String,
      required: false,
    },
  },
  mounted() {
    eventBus.$on(`${busName}::selected`, this.updateMediaItems);

    if (this.variantMediaItems) {
      this.variantMedia = JSON.parse(this.variantMediaItems);
    }
  },
  beforeDestroy() {
    eventBus.$off(`${busName}::selected`, this.updateMediaItems);
  },
  methods: {
    updateMediaItems(productEan) {
      const nextItems = this.variantMedia?.[productEan];
      if (nextItems) {
        const listWrappers = document.querySelectorAll('.vch-media-gallery__list');
        listWrappers.forEach(wrapper => {
          wrapper.innerHTML = '';
        });

        nextItems.forEach((variantImages, i) => {
          if (variantImages[0].media === 'video') {
            this.updateNewVideo(variantImages, i);
          } else if (variantImages[0].media === 'image') {
            this.appendNewImage(variantImages, i);
          }
        });
      }
      document
        .querySelector('#vch-media-gallery__item-0')
        .classList.add('--packshot');

      const imgEle = document.querySelector('#vch-media-gallery__item-0 img');
      if (imgEle) {
        imgEle.id = 'main-image';
      }

      this.lastUpdate = Date.now();
      //update the image carousel 
      const productImages = nextItems.map(imageSet => {
        const image900 = imageSet.find(image => image.width === "900");
        return image900 ? { src: image900.url } : null;
      })
        .filter(Boolean); // remove nulls
      eventBus.$emit('update-product-images', productImages);
    },

    appendNewImage(imageData, index) {
      const mobileParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-mobile');
      const desktopParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-desktop');
      const previousNode = document.querySelector('.vch-media-gallery__item__image');

      const imageListItem = previousNode.cloneNode(true);
      imageListItem.classList.add('vch-media-gallery__item');
      imageListItem.id = `vch-media-gallery__item-${index}`;

      mobileParentElement.append(imageListItem);
      this.setImageAttribute(imageListItem.firstChild.firstChild, imageData);

      if (index === 0) {
        const desktopImageItem = previousNode.cloneNode(true);
        desktopImageItem.classList.add('vch-media-gallery__item');
        desktopImageItem.id = `vch-media-gallery__item-${index}`;

        desktopParentElement.append(desktopImageItem);
        this.setImageAttribute(desktopImageItem.firstChild.firstChild, imageData);
      }
    },

    updateNewVideo(imageData, index) {
      const mobileParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-mobile');
      const desktopParentElement = document.querySelector('.vch-media-gallery__list.vch-media-gallery-desktop');
      const previousNode = document.querySelector('.vch-media-gallery__item__video');
      const videoListItem = previousNode.cloneNode(true);
      videoListItem.classList.add('vch-media-gallery__item');
      videoListItem.id = `vch-media-gallery__item-${index}`;
      mobileParentElement.append(videoListItem);
      this.setVideoAttribute(videoListItem.firstChild, imageData);

      if (index === 0) {
        const desktopVideoListItem = previousNode.cloneNode(true);
        desktopVideoListItem.classList.add('vch-media-gallery__item');
        desktopVideoListItem.id = `vch-media-gallery__item-${index}`;

        desktopParentElement.append(desktopVideoListItem);
        this.setImageAttribute(desktopVideoListItem.firstChild, imageData);
      }
    },

    setImageAttribute(pictureElm, imageData) {
      pictureElm.querySelector('img').setAttribute('src', imageData[0].url);
      const sources = pictureElm.querySelectorAll('source');
      sources.forEach((srcElm, index) => {
        if (index < imageData.length) {
          const widthKey = imageData[index].width;
          if (widthKey) {
            srcElm.setAttribute('srcset', imageData[index].url);
          }
        }
      });
    },
    setVideoAttribute(pictureElm, imageData) {
      imageData.forEach((srcElm, index) => {
        let youtubeIdDesktop, youtubeIdMobile;
        if (srcElm.width === '1073') {
          youtubeIdDesktop = srcElm.desktopUrl;
          let youtubeUrlDesktop =
            'https://www.youtube.com/embed/' +
            youtubeIdDesktop +
            '?rel=0&autoplay=0&mute=0&loop=1&color=white&controls=1&modestbranding=1&playsinline=1&enablejsapi=1';
          pictureElm.querySelector('.youtube-player--desktop').src =
            youtubeUrlDesktop;

          youtubeIdMobile = srcElm.mobileUrl
            ? srcElm.mobileUrl
            : youtubeIdDesktop;
          let youtubeUrlMobile =
            'https://www.youtube.com/embed/' +
            youtubeIdMobile +
            '?rel=0&autoplay=0&mute=0&loop=1&color=white&controls=1&modestbranding=1&playsinline=1&enablejsapi=1';
          pictureElm.querySelector('.youtube-player--mobile').src =
            youtubeUrlMobile;
        }
      });
    },
  },
};
</script>
